(function () {
  const SELECTORS = {
    modal: 'free-gift-modal',
    close: '[data-free-gift-close]',
    item: '[data-free-gift-item]',
    variant: '[data-free-gift-variant]',
    pick: '[data-free-gift-pick]',
    claim: '[data-free-gift-claim]',
    progress: '[data-free-gift-progress]',
    progressMessage: '[data-free-gift-progress-message]',
    progressMobileMessage: '[data-free-gift-progress-mobile-message]',
    progressToggle: '[data-free-gift-progress-toggle]',
    progressToggleIcon: '[data-free-gift-progress-toggle-icon]',
    progressClaim: '[data-free-gift-progress-claim]',
    progressClaimMobile: '[data-free-gift-progress-claim-mobile]',
    progressCheck: '[data-free-gift-progress-check]',
    progressTrack: '[data-free-gift-progress-track]',
    progressFill: '[data-free-gift-progress-fill]',
    progressGoal: '[data-free-gift-progress-goal]',
    productProgress: '[data-free-gift-progress][data-placement="product"]',
    panel: '[data-free-gift-panel]',
    dismiss: '[data-free-gift-dismiss]',
    stage: '[data-free-gift-stage]',
    stageLabel: '[data-free-gift-stage-label]',
    photo: '[data-free-gift-photo]',
    face: '[data-free-gift-face]',
    design: '[data-free-gift-design]',
    size: '[data-free-gift-size]',
    sizeNote: '[data-free-gift-size-note]',
    name: '[data-free-gift-name]',
    phone: '[data-free-gift-phone]',
    blank: '[data-free-gift-blank]',
    count: '[data-free-gift-count]',
    value: '[data-free-gift-value]',
    valueAmount: '[data-free-gift-value-amount]',
    diameter: '[data-free-gift-diameter]',
    thresholdText: '[data-free-gift-threshold-text]',
    kicker: '[data-free-gift-kicker]',
    error: '[data-free-gift-error]',
    notice: '[data-free-gift-notice]',
    noticeOpen: '[data-free-gift-notice-open]',
    noticeHide: '[data-free-gift-notice-hide]',
    edit: '[data-free-gift-edit]',

    cartForm: 'form[action*="/cart/add"]',
    shtCartDrawer: 'sht-cart-drwr',
    shtCartDrawerForm: 'sht-cart-drwr-frm',
    shtCartNotification: 'sht-cart-noti'
  };

  const CART_ENDPOINTS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  const CHECK_DELAY = 350;
  const PROPERTY_NAME = '_free_gift';
  const PROPERTY_VALUE = 'true';
  // Which surface granted a complimentary line. This modal is no longer the
  // only one: the Fitting Room configurator grants its own engraved nametag
  // when a set clears the same threshold, and stamps the same _free_gift
  // property. _free_gift therefore answers "is this a gift?" but NOT "is
  // this mine to mutate?" — and those are different questions, because
  // gift conversion and enforceSingleGift() have separate responsibilities.
  const SOURCE_PROPERTY = '_free_gift_source';
  const SOURCE_SELF = 'free-gift-modal';
  // Written by whichever surface granted the line, naming the PAID variant
  // that same item should fall back to if the cart later stops qualifying.
  // The Fitting Room's complimentary nametag is a separate hidden $0
  // PRODUCT, not a discounted variant of the paid one — so a gift line can
  // only be "re-priced" by swapping it for that paid variant. Stripping
  // _free_gift alone would leave a permanently free line that no cleanup
  // path can even identify. The line carries its own upgrade path because
  // the gift->paid mapping lives in the configurator's section settings,
  // which this store-wide script cannot see.
  const UPGRADE_PROPERTY = '_free_gift_upgrade_variant';
  const CONVERSION_PROPERTY = '_free_gift_conversion_id';
  const CONVERTED_PROPERTY = '_free_gift_repriced_from';

  // Engraving. Visible keys match the store's nametag convention (the PDP
  // form and the cart templates read "Front Side Text" / "Back Side Text"),
  // so fulfilment sees one format whichever surface sold the tag. The
  // _engraving_* copies are private (hidden at checkout) for automations.
  const ENGRAVING = {
    front: 'Front Side Text',
    back: 'Back Side Text',
    blankLabel: 'Engraving',
    blankValue: 'None — blank tag',
    privateName: '_engraving_name',
    privatePhone: '_engraving_phone',
    privateBlank: '_engraving_blank'
  };
  // Every key that describes engraving, including the Fitting Room's older
  // spelling, so an edit replaces the engraving instead of leaving two.
  const ENGRAVING_KEYS = [
    ENGRAVING.front, ENGRAVING.back, ENGRAVING.blankLabel,
    ENGRAVING.privateName, ENGRAVING.privatePhone, ENGRAVING.privateBlank,
    'Engraving name', 'Engraving phone'
  ];
  const NAME_MAX = 12;
  const PHONE_MAX = 14;
  // Letters in any script (upper or lower case), digits, spaces and . ' ’ & -
  const NAME_DISALLOWED = /[^\p{L}\p{M}\p{N} .'’&-]/gu;
  const PHONE_DISALLOWED = /[^0-9+ ()-]/g;
  // "Not now" is remembered for the browser session only.
  const SESSION_DISMISSED = 'lb:free-gift:dismissed';
  const SESSION_NOTICE_HIDDEN = 'lb:free-gift:notice-hidden';
  const OWN_REQUEST = '__freeGiftOwnRequest';

  const modal = document.querySelector(SELECTORS.modal);
  if (!modal) return;

  let isChecking = false;
  let isMutatingGift = false;
  let recheckQueued = false;
  // Did the bag hold a gift at the last check? (null until the first one.)
  let lastHadGift = null;
  let checkTimer = null;
  let lastProgressPercent = null;
  let lastKnownCart = null;

  const threshold = Number(modal.dataset.threshold || 0);
  const claimLabel = modal.dataset.claimLabel || 'Add to my order';
  const saveLabel = modal.dataset.saveLabel || 'Save engraving';
  const giftProducts = parseJsonAttribute(modal.dataset.giftProducts, []);
  const giftVariantIds = giftProducts.flatMap((product) => {
    return (product.variants || []).map((variant) => Number(variant.id));
  });

  if (!threshold || !giftVariantIds.length) return;

  // Single source of truth for the threshold, in the shop's BASE currency
  // cents. The Fitting Room prefers this over its own section setting, so
  // the two surfaces cannot drift apart when one is edited in the admin.
  window.LB_FREE_GIFT_THRESHOLD_BASE_CENTS = threshold;

  // Read LIVE on every call, never snapshotted. Shopify populates
  // window.Shopify.currency from an inline script, and this file is
  // deferred — a value cached at load time can be the pre-hydration
  // default. On a store presenting IDR (rate ~16000) a cached rate of 1
  // turns a Rp 3,200,000 threshold into Rp 200, i.e. every cart qualifies.
  // Number() also copes with the rate arriving as a string ("16000.0").
  function getCurrencyRate() {
    const rate = window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.rate;

    const parsedRate = Number(rate);
    return Number.isFinite(parsedRate) && parsedRate > 0 ? parsedRate : 1;
  }

  // Threshold in the shopper's ACTIVE presentment currency, in sub-units —
  // the same units /cart.js reports final_line_price in, so the comparison
  // is apples to apples in every market. Zero-decimal currencies need no
  // special case: Shopify reports those in sub-units too.
  function getActiveThreshold() {
    return Math.round(threshold * getCurrencyRate());
  }

  function parseJsonAttribute(value, fallback) {
    if (!value) return fallback;

    try {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = value;
      return JSON.parse(textarea.value);
    } catch (error) {
      console.warn('[free-gift] Could not parse gift products JSON.', error);
      return fallback;
    }
  }

  function getRootUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function buildCartUrl(path) {
    return getRootUrl() + path.replace(/^\//, '');
  }

  async function fetchJson(url, options) {
    const response = await fetch(url, options);

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || error.message || response.statusText);
    }

    return response.json();
  }

  function getCart() {
    return fetchJson(buildCartUrl('cart.js'));
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function lineProperty(item, name) {
    return item && item.properties ? item.properties[name] : undefined;
  }

  // "Is this line a complimentary gift?" — whoever granted it.
  //
  // Matching on variant id alone meant a free nametag earned in the Fitting
  // Room was invisible here: hasGift() returned false, so checkCartState()
  // opened this modal and offered the shopper a SECOND free gift on top of
  // the one already in their bag, immediately after they added their set.
  function isGiftLine(item) {
    return giftVariantIds.includes(Number(item.variant_id)) ||
      String(lineProperty(item, PROPERTY_NAME)) === PROPERTY_VALUE;
  }

  // Ownership is separate from gift detection: other surfaces keep their
  // own mapping, while the global handler can safely re-price either kind.
  function isModalManagedGift(item) {
    if (!isGiftLine(item)) return false;
    const source = lineProperty(item, SOURCE_PROPERTY);
    if (source) return String(source) === SOURCE_SELF;
    return giftVariantIds.includes(Number(item.variant_id));
  }

  function isConvertedGiftLine(item) {
    return !isGiftLine(item) && !!String(lineProperty(item, CONVERTED_PROPERTY) || '');
  }

  function isQuietRequalification(cart) {
    return !!cart && cart.items.some(isConvertedGiftLine);
  }

  function newConversionId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  function paidVariantForGift(item) {
    const configured = giftProducts.flatMap((product) => product.variants || [])
      .find((variant) => Number(variant.id) === Number(item.variant_id));
    const pointer = lineProperty(item, UPGRADE_PROPERTY);
    const external = isGiftLine(item) && !isModalManagedGift(item);
    const id = Number(external && pointer !== undefined ? pointer : (configured && configured.paid) || pointer);
    return Number.isSafeInteger(id) && id > 0 && id !== Number(item.variant_id) && !giftVariantIds.includes(id) ? id : 0;
  }

  function convertedTagPrice(item) {
    const price = Number(item.final_price);
    return Number.isFinite(price) ? price : Number(item.final_line_price || 0) / Math.max(Number(item.quantity) || 1, 1);
  }

  function renderRepricedNotes(cart) {
    if (!cart || !document.body) return;
    const used = new Set();
    cart.items.forEach((item, index) => {
      if (!isConvertedGiftLine(item)) return;
      const rows = document.querySelectorAll('#cartItem-' + (index + 1) + ', #cartDrawerItem-' + (index + 1));
      rows.forEach((row) => {
        const target = row.querySelector('.cart-drawer__product-info--title, .cart-item__product > .wb-break-word') || row;
        let note = target.querySelector('[data-free-gift-repriced-note]');
        if (!note) {
          note = document.createElement('p');
          note.className = 'subtext color-light mt-8 mb-0 wb-break-word';
          note.setAttribute('data-free-gift-repriced-note', '');
          note.setAttribute('role', 'status');
          target.appendChild(note);
        }
        updateText(note, 'Your personalised name tag is now ' + formatMoney(convertedTagPrice(item)) + '. Your engraving has been kept.');
        used.add(note);
      });
    });
    document.querySelectorAll('[data-free-gift-repriced-note]').forEach((note) => {
      if (!used.has(note)) note.remove();
    });
  }

  function eligibleSubtotal(cart) {
    return cart.items
      .filter((item) => !isGiftLine(item))
      .reduce((total, item) => total + Number(item.final_line_price || 0), 0);
  }

  function giftLines(cart) {
    return cart.items.filter(isGiftLine);
  }

  // Only the subset this modal is allowed to mutate.
  function modalGiftLines(cart) {
    return cart.items.filter(isModalManagedGift);
  }

  function externalGiftLines(cart) {
    return cart.items.filter((item) => isGiftLine(item) && !isModalManagedGift(item));
  }

  function hasGift(cart) {
    return giftLines(cart).length > 0;
  }

  function interpolateMessage(template, values) {
    return Object.keys(values).reduce((message, key) => {
      return message.replace(new RegExp('{{\\s*' + key + '\\s*}}', 'g'), values[key]);
    }, template || '');
  }

  function updateText(element, text) {
    if (element && element.textContent !== text) {
      element.textContent = text;
    }
  }

  function captureCurrentProgressPercent() {
    const fill = document.querySelector(SELECTORS.progressFill);
    if (!fill) return;

    const track = fill.closest(SELECTORS.progressTrack);
    const width = parseFloat(fill.style.width || (track && track.getAttribute('aria-valuenow')));
    if (!Number.isNaN(width)) {
      lastProgressPercent = width;
    }
  }

  function applyAnimatedProgressWidth(fill, percent) {
    const targetPercent = Math.max(0, Math.min(percent, 100));

    if (
      lastProgressPercent !== null &&
      lastProgressPercent !== targetPercent &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      fill.style.transition = 'none';
      fill.style.width = lastProgressPercent + '%';
      fill.offsetWidth;

      window.requestAnimationFrame(() => {
        fill.style.transition = '';
        fill.style.width = targetPercent + '%';
      });
    } else {
      fill.style.width = targetPercent + '%';
    }
  }

  function animateRenderedProgressBars(root) {
    if (lastProgressPercent === null || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const scope = root && root.querySelectorAll ? root : document;
    const fills = [];

    if (scope.matches && scope.matches(SELECTORS.progressFill)) {
      fills.push(scope);
    }

    fills.push(...scope.querySelectorAll(SELECTORS.progressFill));

    let animatedTargetPercent = null;

    fills.forEach((fill) => {
      const track = fill.closest(SELECTORS.progressTrack);
      const targetPercent = parseFloat(fill.style.width || (track && track.getAttribute('aria-valuenow')));

      if (Number.isNaN(targetPercent) || targetPercent === lastProgressPercent) return;

      applyAnimatedProgressWidth(fill, targetPercent);
      animatedTargetPercent = targetPercent;
    });

    if (animatedTargetPercent !== null) {
      lastProgressPercent = animatedTargetPercent;
    }
  }

  function updateProgressBars(cart) {
    if (cart) lastKnownCart = cart;
    renderRepricedNotes(cart);

    const progressBars = document.querySelectorAll(SELECTORS.progress);
    if (!progressBars.length || !cart) return;

    const activeThreshold = getActiveThreshold();
    const subtotal = eligibleSubtotal(cart);
    const remaining = Math.max(activeThreshold - subtotal, 0);
    const percent = activeThreshold > 0 ? Math.min(Math.round((subtotal / activeThreshold) * 100), 100) : 0;
    const unlocked = remaining === 0;
    const cartHasGift = hasGift(cart);

    progressBars.forEach((progress) => {
      const message = progress.querySelector(SELECTORS.progressMessage);
      const mobileMessage = progress.querySelector(SELECTORS.progressMobileMessage);
      const claim = progress.querySelector(SELECTORS.progressClaim);
      const claimMobile = progress.querySelector(SELECTORS.progressClaimMobile);
      const check = progress.querySelector(SELECTORS.progressCheck);
      const track = progress.querySelector(SELECTORS.progressTrack);
      const fill = progress.querySelector(SELECTORS.progressFill);
      const goal = progress.querySelector(SELECTORS.progressGoal);
      const remainingTemplate = progress.dataset.remainingMessage || '{{ amount }} left for the GIFT!';
      const remainingTemplateMobile = progress.dataset.remainingMessageMobile || 'Spend {{ amount }} and claim free name tag';
      const unlockedTemplate = progress.dataset.unlockedMessage || 'You unlocked a Free Nametag';
      const claimLabel = progress.dataset.claimLabel || 'CLAIM';

      progress.hidden = false;
      progress.removeAttribute('data-free-gift-pending');
      progress.classList.toggle('is-unlocked', unlocked);
      progress.classList.toggle('has-gift', cartHasGift);

      const progressText = unlocked
        ? interpolateMessage(unlockedTemplate, {
            amount: formatMoney(remaining),
            threshold: formatMoney(activeThreshold),
            total: formatMoney(subtotal)
          })
        : interpolateMessage(remainingTemplate, {
            amount: formatMoney(remaining),
            threshold: formatMoney(activeThreshold),
            total: formatMoney(subtotal)
      });

      const progressTextMobile = unlocked
        ? interpolateMessage(unlockedTemplate, {
            amount: formatMoney(remaining),
            threshold: formatMoney(activeThreshold),
            total: formatMoney(subtotal)
          })
        : interpolateMessage(remainingTemplateMobile, {
            amount: formatMoney(remaining),
            threshold: formatMoney(activeThreshold),
            total: formatMoney(subtotal)
      });

      if (message) {
        updateText(message, progressText);
      }

      if (mobileMessage) {
        updateText(mobileMessage, progressTextMobile);
      }

      if (claim) {
        updateText(claim, claimLabel);
        claim.hidden = !unlocked || cartHasGift;
      }

      if (claimMobile) {
        updateText(claimMobile, claimLabel);
        claimMobile.hidden = !unlocked || cartHasGift;
      }

      if (check) {
        check.hidden = !unlocked;
      }

      if (track) {
        track.setAttribute('aria-valuenow', String(percent));
      }

      if (fill) {
        applyAnimatedProgressWidth(fill, percent);
      }

      if (goal) {
        updateText(goal, formatMoney(activeThreshold));
      }

      progress.dataset.freeGiftNormalized = 'true';
    });

    lastProgressPercent = percent;
    updateProductProgressOffset();
  }

  function updateProductProgressOffset() {
    const productProgressBars = Array.from(document.querySelectorAll(SELECTORS.productProgress));
    if (!productProgressBars.length) return;

    const visibleHeight = productProgressBars.reduce((height, productProgress) => {
      const rect = productProgress.getBoundingClientRect();
      const styles = window.getComputedStyle(productProgress);
      const isVisible = styles.display !== 'none' && styles.visibility !== 'hidden' && rect.height > 0;

      return isVisible ? Math.max(height, Math.ceil(rect.height)) : height;
    }, 0);

    if (!visibleHeight) return;

    document.documentElement.style.setProperty('--free-gift-product-progress-offset', visibleHeight + 32 + 'px');
    document.body.classList.add('has-free-gift-product-progress');
  }

  function toggleProductProgress(progress) {
    if (!progress || progress.dataset.placement !== 'product') return;

    const isOpen = !progress.classList.contains('is-mobile-open');
    const toggle = progress.querySelector(SELECTORS.progressToggle);
    const icon = progress.querySelector(SELECTORS.progressToggleIcon);

    progress.classList.toggle('is-mobile-open', isOpen);

    if (toggle) {
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    if (icon) {
      icon.textContent = isOpen ? '-' : '+';
    }

    updateProductProgressOffset();
  }

  /* Is a guided configurator currently occupying the screen?
   *
   * The Lillebjörn Fitting Room is a multi-step set builder that dispatches
   * "cart:refresh" on add — which schedules a cart check here — and grants
   * its own complimentary nametag against this very threshold. Popping this
   * dialog over it interrupts a shopper mid-build to offer a reward they
   * have usually already earned.
   *
   * Three independent signals, any of which counts. The DOM check is last
   * and is the safety net: it holds even if the configurator's own script
   * failed to load, or an older build without the flags is deployed, so
   * suppression never depends on the two files shipping together.
   */
  function openNativeModal() {
    try {
      return document.querySelector('dialog:modal');
    } catch (error) {
      // Browsers without :modal: an open <dialog> is the closest signal.
      return document.querySelector('dialog[open]');
    }
  }

  function isConfiguratorActive() {
    if (window.LB_FR_ACTIVE) return true;
    if (document.body && document.body.classList.contains('lb-fr-open')) return true;
    // Find My Dog's Size is a drawer, not a native dialog: an automatic offer
    // must not open over it mid-flow (it re-checks when the drawer closes).
    if (document.querySelector('lillebjorn-fit-finder[data-open="true"]')) return true;
    return !!document.querySelector('lillebjorn-fitting-room');
  }

  /* ────────────────────────────────────────────────────────────────────
   * THE ATELIER — selection, stage, open/close.
   *
   * ui is the single source of truth for what the shopper has chosen.
   * Every control writes to it and every view reads from it, so the photo,
   * the size availability and the cart payload cannot disagree.
   * ──────────────────────────────────────────────────────────────────── */

  // The snippet decides the opening selection (Pebble, 25 mm by default,
  // with stock-aware fallbacks) and says so in data-default-design.
  const defaultProduct = giftProducts.find((product) => product.design === modal.dataset.defaultDesign) ||
    giftProducts[0] || {};
  const anyInStock = modal.dataset.anyAvailable !== 'false';
  const ui = {
    design: defaultProduct.design || '',
    size: String(defaultProduct.defaultSize || '25'),
    face: 'front',
    name: '',
    phone: '',
    blank: false,
    mode: 'claim',      // 'claim' adds a new gift line, 'edit' rewrites one
    editLine: null,
    lastFocus: null
  };

  const el = {
    panel: modal.querySelector(SELECTORS.panel),
    stage: modal.querySelector(SELECTORS.stage),
    stageLabel: modal.querySelector(SELECTORS.stageLabel),
    photos: Array.from(modal.querySelectorAll(SELECTORS.photo)),
    faces: Array.from(modal.querySelectorAll(SELECTORS.face)),
    designs: Array.from(modal.querySelectorAll(SELECTORS.design)),
    sizes: Array.from(modal.querySelectorAll(SELECTORS.size)),
    sizeNote: modal.querySelector(SELECTORS.sizeNote),
    name: modal.querySelector(SELECTORS.name),
    phone: modal.querySelector(SELECTORS.phone),
    blank: modal.querySelector(SELECTORS.blank),
    counts: Array.from(modal.querySelectorAll(SELECTORS.count)),
    value: modal.querySelector(SELECTORS.value),
    valueAmount: modal.querySelector(SELECTORS.valueAmount),
    diameter: modal.querySelector(SELECTORS.diameter),
    thresholdText: Array.from(modal.querySelectorAll(SELECTORS.thresholdText)),
    kicker: modal.querySelector(SELECTORS.kicker),
    error: modal.querySelector(SELECTORS.error),
    claim: modal.querySelector(SELECTORS.claim),
    notice: document.querySelector(SELECTORS.notice),
    body: modal.querySelector('[data-free-gift-body]'),
    side: modal.querySelector('.free-gift-modal__side')
  };

  let closeTimer = null;
  let noticeTimer = null;

  // sessionStorage can throw (private mode, blocked storage). Losing the
  // flag only means the dialog may appear once more — never an error.
  function sessionFlag(key, value) {
    try {
      if (value === undefined) return window.sessionStorage.getItem(key) === '1';
      window.sessionStorage.setItem(key, '1');
    } catch (error) {
      return false;
    }
    return true;
  }

  const isDismissed = () => sessionFlag(SESSION_DISMISSED);
  const isNoticeHidden = () => sessionFlag(SESSION_NOTICE_HIDDEN);

  function productFor(design) {
    return giftProducts.find((product) => product.design === design) || null;
  }

  function variantFor(design, size) {
    const product = productFor(design);
    if (!product) return null;
    return (product.variants || []).find((variant) => String(variant.size) === String(size)) || null;
  }

  // A size is choosable when it is in stock — or when it is the very
  // variant the shopper already holds (editing must never lock them out of
  // the tag they have).
  function sizeChoosable(design, size) {
    const variant = variantFor(design, size);
    if (!variant) return false;
    if (variant.available) return true;
    return !!(ui.editLine && Number(ui.editLine.variant_id) === Number(variant.id));
  }

  function designLabel(design) {
    const product = productFor(design);
    return product ? product.title : design;
  }

  function sanitizeName(value) {
    return value.replace(NAME_DISALLOWED, '').replace(/^\s+/, '').replace(/\s{2,}/g, ' ').slice(0, NAME_MAX);
  }

  function sanitizePhone(value) {
    return value.replace(PHONE_DISALLOWED, '').replace(/(?!^)\+/g, '').slice(0, PHONE_MAX);
  }

  function designChoosable(design) {
    return el.sizes.some((input) => sizeChoosable(design, input.value));
  }

  /* ── Views ─────────────────────────────────────────────────────────── */

  // Sold-out designs are disabled; if the selected one sells out, the
  // selection moves to the first design that still has stock.
  function syncDesigns() {
    if (!designChoosable(ui.design)) {
      const fallback = giftProducts.find((product) => designChoosable(product.design));
      if (fallback) {
        ui.design = fallback.design;
        ui.size = String(fallback.defaultSize || ui.size);
      }
    }
    el.designs.forEach((input) => {
      const choosable = designChoosable(input.value);
      input.disabled = !choosable;
      const note = input.parentElement.querySelector('.free-gift-modal__design-note');
      if (note) {
        if (!note.dataset.note) note.dataset.note = note.textContent;
        note.textContent = choosable ? (note.dataset.note === 'Unavailable' ? '' : note.dataset.note) : 'Unavailable';
      }
    });
  }

  function noStockLeft() {
    return !giftProducts.some((product) => designChoosable(product.design));
  }

  function syncSizes() {
    const sizes = el.sizes.map((input) => input.value);

    if (!sizeChoosable(ui.design, ui.size)) {
      const fallback = sizes.find((size) => sizeChoosable(ui.design, size));
      if (fallback) ui.size = fallback;
    }

    const unavailable = [];
    el.sizes.forEach((input) => {
      const choosable = sizeChoosable(ui.design, input.value);
      input.disabled = !choosable;
      input.checked = input.value === ui.size;
      if (!choosable) unavailable.push(input.value + ' mm');
    });

    if (el.sizeNote) {
      el.sizeNote.hidden = !unavailable.length;
      el.sizeNote.textContent = unavailable.length
        ? designLabel(ui.design) + ' in ' + unavailable.join(' and ') + ' is unavailable right now.'
        : '';
    }
  }

  function syncStage() {
    let active = null;
    el.photos.forEach((photo) => {
      const match = photo.dataset.design === ui.design &&
        photo.dataset.size === ui.size &&
        photo.dataset.face === ui.face;
      photo.classList.toggle('is-active', match);
      if (match) active = photo;
    });

    // No photograph for this face: show the front rather than an empty plinth.
    if (!active) {
      el.photos.forEach((photo) => {
        if (photo.dataset.design === ui.design && photo.dataset.size === ui.size && photo.dataset.face === 'front') {
          photo.classList.add('is-active');
        }
      });
    }

    if (el.stage) el.stage.dataset.face = ui.face;

    el.faces.forEach((button) => {
      button.setAttribute('aria-pressed', button.dataset.freeGiftFace === ui.face ? 'true' : 'false');
    });

    if (el.diameter) el.diameter.textContent = 'Ø ' + ui.size + ' mm';

    const variant = variantFor(ui.design, ui.size);
    const value = variant && Number(variant.value);
    if (el.value) {
      el.value.hidden = !(value > 0);
      if (value > 0 && el.valueAmount) {
        el.valueAmount.textContent = formatMoney(value).replace(/[.,]00(?=\D*$)/, '');
      }
    }
  }

  function setFace(face, announce) {
    if (face !== 'front' && face !== 'back') return;
    const changed = ui.face !== face;
    ui.face = face;
    syncStage();
    if (announce && changed && el.stageLabel) {
      el.stageLabel.textContent = 'Showing the ' + face + ' of the tag.';
    }
  }

  function syncFields() {
    if (el.name && el.name.value !== ui.name) el.name.value = ui.name;
    if (el.phone && el.phone.value !== ui.phone) el.phone.value = ui.phone;
    if (el.blank) el.blank.checked = ui.blank;
    [el.name, el.phone].forEach((input) => {
      if (input) input.disabled = ui.blank;
    });
    el.counts.forEach((count) => {
      const key = count.dataset.freeGiftCount;
      const length = key === 'name' ? ui.name.length : ui.phone.length;
      count.textContent = length + '/' + (key === 'name' ? NAME_MAX : PHONE_MAX);
    });
    el.designs.forEach((input) => {
      input.checked = input.value === ui.design;
    });
  }

  function syncAll() {
    syncDesigns();
    syncSizes();
    syncFields();
    syncStage();
    if (el.claim) el.claim.disabled = noStockLeft() && ui.mode === 'claim';
    queueFit();
  }

  function setError(message, field) {
    if (el.error) el.error.textContent = message || '';
    modal.querySelectorAll('.free-gift-modal__field').forEach((node) => node.classList.remove('is-invalid'));
    if (field) {
      const wrap = field.closest('.free-gift-modal__field');
      if (wrap) wrap.classList.add('is-invalid');
      field.setAttribute('aria-invalid', 'true');
    } else {
      [el.name, el.phone].forEach((input) => input && input.removeAttribute('aria-invalid'));
    }
  }

  function validate() {
    if (noStockLeft()) {
      setError('The complimentary tags are sold out right now.');
      return false;
    }
    if (!variantFor(ui.design, ui.size) || !sizeChoosable(ui.design, ui.size)) {
      setError('This tag is unavailable right now. Please choose another design or size.');
      return false;
    }
    if (!ui.blank && !ui.name.trim()) {
      setError('Add your dog’s name for the front, or choose a blank tag.', el.name);
      setFace('front');
      if (el.name) el.name.focus();
      return false;
    }
    setError('');
    return true;
  }

  /* ── Line item properties ──────────────────────────────────────────── */

  // Visible keys follow the store's existing nametag convention (PDP and
  // cart both read "Front Side Text" / "Back Side Text"); the private
  // _engraving_* keys are the machine-readable copy for automations.
  function engravingProperties() {
    if (ui.blank) {
      return {
        [ENGRAVING.blankLabel]: ENGRAVING.blankValue,
        [ENGRAVING.privateBlank]: 'true'
      };
    }

    const properties = {};
    const name = ui.name.trim();
    const phone = ui.phone.trim();
    if (name) {
      properties[ENGRAVING.front] = name;
      properties[ENGRAVING.privateName] = name;
    }
    if (phone) {
      properties[ENGRAVING.back] = phone;
      properties[ENGRAVING.privatePhone] = phone;
    }
    return properties;
  }

  // Keep everything a line already carries (gift markers, the Fitting
  // Room's upgrade path, anything a future surface adds) and replace only
  // the engraving. /cart/change.js REPLACES the whole property bag, so
  // anything not copied here is deleted.
  function withEngraving(existing, engraving) {
    const merged = {};
    Object.keys(existing || {}).forEach((key) => {
      if (ENGRAVING_KEYS.includes(key)) return;
      const value = existing[key];
      if (value === null || value === undefined || value === '') return;
      merged[key] = value;
    });
    Object.keys(engraving || {}).forEach((key) => {
      if (engraving[key] !== '') merged[key] = engraving[key];
    });
    return merged;
  }

  function engravingFromLine(line) {
    const properties = (line && line.properties) || {};
    const blank = String(properties[ENGRAVING.privateBlank]) === 'true' ||
      String(properties[ENGRAVING.blankLabel] || '').indexOf('None') === 0;
    return {
      blank,
      name: blank ? '' : String(properties[ENGRAVING.front] || properties['Engraving name'] || ''),
      phone: blank ? '' : String(properties[ENGRAVING.back] || properties['Engraving phone'] || '')
    };
  }

  /* ── One screen, no scrolling ────────────────────────────────────────
   *
   * The modal never scrolls. The content is measured on the real screen and
   * the roomiest layout level that fits is kept (CSS: "fit levels"):
   *   1 as designed · 2 compact · 3 condensed · 4 extremes (data-tiny)
   * Phones held upright get the bottom sheet; everything wider, including a
   * phone turned sideways, gets the split panel (data-short under 500px).
   * While typing, Design/Size fold away only if that is what it takes.
   * Below the floor (~320×250 visible) the form scrolls rather than clip.
   * Re-runs on resize, rotation, keyboard, font load and content changes.
   * ──────────────────────────────────────────────────────────────────── */

  let fitting = false;
  let fitQueued = false;

  function visibleHeight() {
    const viewport = window.visualViewport;
    return Math.round((viewport && viewport.height) || window.innerHeight);
  }

  function overflows() {
    return [el.panel, el.side, el.body].some((box) => box && box.scrollHeight - box.clientHeight > 1);
  }

  function fit() {
    fitQueued = false;
    if (fitting || modal.hidden || !el.panel) return;
    fitting = true;

    const width = window.innerWidth;
    const height = visibleHeight();
    modal.style.setProperty('--fgm-vvh', height + 'px');

    const shape = width >= 768 || (width >= 560 && height < 500) ? 'split' : 'sheet';
    modal.dataset.shape = shape;
    if (shape === 'split' && height < 500) modal.dataset.short = '';
    else delete modal.dataset.short;

    delete modal.dataset.focus;
    delete modal.dataset.tiny;
    delete modal.dataset.squeeze;
    delete modal.dataset.overflow;

    let fits = false;
    for (const level of ['1', '2', '3']) {
      modal.dataset.fit = level;
      void el.panel.offsetHeight;
      if (!overflows()) { fits = true; break; }
    }

    if (!fits && modal.classList.contains('is-typing')) {
      modal.dataset.focus = 'engraving';
      void el.panel.offsetHeight;
      fits = !overflows();
    }

    if (!fits) {
      modal.dataset.tiny = '';
      void el.panel.offsetHeight;
      fits = !overflows();
    }

    // Last step, for the smallest screens with an error line showing: the
    // photo band (sheet) or the Design/Size headings (landscape) step aside,
    // and while typing the engraving heading row does too.
    if (!fits) {
      modal.dataset.squeeze = '';
      void el.panel.offsetHeight;
      fits = !overflows();
    }

    if (!fits) modal.dataset.overflow = 'scroll';
    fitting = false;
  }

  // Animation frames pause in background tabs; a timer backs them up.
  function queueFit() {
    if (fitQueued) return;
    fitQueued = true;
    let done = false;
    const run = () => {
      if (done) return;
      done = true;
      fit();
    };
    window.requestAnimationFrame(run);
    window.setTimeout(run, 150);
  }

  /* ── Open / close ──────────────────────────────────────────────────── */

  function prepare(options) {
    const line = options && options.editLine;
    ui.mode = line ? 'edit' : 'claim';
    ui.editLine = line || null;
    ui.face = 'front';

    if (line) {
      const product = giftProducts.find((p) => (p.variants || []).some((v) => Number(v.id) === Number(line.variant_id)));
      const variant = product && product.variants.find((v) => Number(v.id) === Number(line.variant_id));
      if (product) ui.design = product.design;
      if (variant) ui.size = String(variant.size);
      const engraving = engravingFromLine(line);
      ui.name = sanitizeName(engraving.name);
      ui.phone = sanitizePhone(engraving.phone);
      ui.blank = engraving.blank;
    }

    if (el.claim) {
      el.claim.textContent = ui.mode === 'edit' ? saveLabel : claimLabel;
      el.claim.removeAttribute('aria-busy');
    }
    if (el.kicker) {
      el.kicker.textContent = ui.mode === 'edit' ? 'Your complimentary tag' : 'Included with your order';
    }
    el.thresholdText.forEach((node) => {
      updateText(node, formatMoney(getActiveThreshold()).replace(/[.,]00(?=\D*$)/, ''));
    });
    setError('');
    syncAll();
    if (ui.mode === 'claim' && noStockLeft()) {
      setError('The complimentary tags are sold out right now.');
    }

    if (el.body) el.body.scrollTop = 0;
  }

  // Two frames so the entrance transition runs; a timer as well, because
  // browsers pause animation frames in background tabs and an un-hidden
  // but never-opened dialog would sit invisible over the page.
  function nextPaint(callback) {
    let done = false;
    const run = () => {
      if (done) return;
      done = true;
      callback();
    };
    window.requestAnimationFrame(() => window.requestAnimationFrame(run));
    window.setTimeout(run, 120);
  }

  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isPhone = () => window.matchMedia('(max-width: 767px)').matches;

  function onViewportChange() {
    const viewport = window.visualViewport;
    if (!viewport) return;
    const keyboard = Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop);
    modal.style.setProperty('--fgm-kb', Math.round(keyboard) + 'px');
    modal.style.setProperty('--fgm-vvh', Math.round(viewport.height) + 'px');
    queueFit();
  }

  function watchViewport(on) {
    const viewport = window.visualViewport;
    if (!viewport) return;
    const method = on ? 'addEventListener' : 'removeEventListener';
    viewport[method]('resize', onViewportChange);
    viewport[method]('scroll', onViewportChange);
    if (on) onViewportChange();
  }

  // options.userInitiated — set only when the shopper explicitly asked for
  // the dialog (progress-bar Claim, the quiet notice, "Change engraving").
  // Those are honoured unconditionally: silently ignoring a control someone
  // just pressed is a worse failure than an ill-timed popup.
  function openModal(options) {
    const userInitiated = !!(options && options.userInitiated);

    if (!userInitiated && isConfiguratorActive()) {
      // Suppress silently — and make sure we are not already sitting open
      // on top of the configurator from a check that ran before it mounted.
      closeModal();
      return;
    }

    // Automatic opens happen once per session; after a dismissal the quiet
    // notice takes over.
    if (!userInitiated && (isDismissed() || isQuietRequalification(lastKnownCart))) return;

    // Nothing left to give: never interrupt the shopper for it.
    if (!userInitiated && !anyInStock) return;

    // A native modal <dialog> (the home films viewer) sits in the top layer
    // and makes everything else inert: opened now, the offer would be hidden
    // behind it and could not take focus. Wait for it to close, then re-check.
    if (!userInitiated) {
      const blocker = openNativeModal();
      if (blocker) {
        if (!blocker.__freeGiftDeferred) {
          blocker.__freeGiftDeferred = true;
          // Watch the open attribute rather than the 'close' event: every way
          // a dialog closes removes it, and the observer does not depend on
          // the page rendering (Chrome fires 'close' from the rendering steps).
          const watcher = new MutationObserver(() => {
            if (blocker.open && blocker.isConnected) return;
            watcher.disconnect();
            blocker.__freeGiftDeferred = false;
            scheduleCartCheck(0);
          });
          watcher.observe(blocker, { attributes: true, attributeFilter: ['open'] });
        }
        return;
      }
    }

    window.clearTimeout(closeTimer);
    const wasClosed = modal.hidden || !modal.classList.contains('is-open');

    if (wasClosed) {
      if (modal.hidden) ui.lastFocus = document.activeElement;
      prepare(options);
    } else if (options && options.editLine) {
      prepare(options);
    }

    hideNotice();
    modal.hidden = false;
    document.documentElement.classList.add('free-gift-modal-open');
    watchViewport(true);
    fit();

    nextPaint(() => {
      modal.classList.add('is-open');
      fit();
    });

    // Focus the dialog itself, never a text field: on a phone that would
    // throw the keyboard over the tag before the shopper has seen it.
    if (wasClosed && el.panel) el.panel.focus({ preventScroll: true });
  }

  // reason: 'dismiss' (Not now, ×, Esc, backdrop), 'done' (added / saved),
  // or undefined for automatic closes driven by the cart state.
  function closeModal(reason) {
    if (modal.hidden) return;

    const dismissedClaim = reason === 'dismiss' && ui.mode === 'claim';
    if (dismissedClaim) sessionFlag(SESSION_DISMISSED, true);

    modal.classList.remove('is-open', 'is-typing');
    document.documentElement.classList.remove('free-gift-modal-open');
    watchViewport(false);

    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => {
      modal.hidden = true;
      ui.mode = 'claim';
      ui.editLine = null;

      if (dismissedClaim || isQuietRequalification(lastKnownCart)) maybeShowNotice();

      const back = ui.lastFocus;
      ui.lastFocus = null;
      const meaningful = back && back !== document.body && back !== document.documentElement && back.isConnected && !modal.contains(back);
      if (reason && meaningful && typeof back.focus === 'function') {
        back.focus({ preventScroll: true });
      } else if (dismissedClaim && el.notice && !el.notice.hidden) {
        const open = el.notice.querySelector(SELECTORS.noticeOpen);
        if (open) open.focus({ preventScroll: true });
      } else if (reason) {
        // Nothing usable to go back to: the drawer re-rendered under us
        // (add / save replaced the button that opened us), or the opener
        // never took focus (Safari does not focus a clicked button). Land on
        // the drawer's gift line, or the drawer itself, rather than leaving
        // keyboard focus on <body> or inside this now-hidden dialog.
        const drawer = document.querySelector('.js-cart-drawer-wrapper');
        const drawerOpen = drawer && getComputedStyle(drawer).visibility !== 'hidden';
        const target = drawerOpen && (drawer.querySelector('[data-free-gift-edit]') || drawer);
        if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
      }
    }, reducedMotion() ? 0 : 360);
  }

  function trapFocus(event) {
    const focusables = Array.from(modal.querySelectorAll(
      'button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter((node) => node.offsetParent !== null);
    if (!focusables.length) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const active = document.activeElement;

    if (event.shiftKey && (active === first || active === el.panel)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function setBusy(busy) {
    modal.classList.toggle('is-loading', busy);
    if (!el.claim) return;
    if (busy) {
      el.claim.setAttribute('aria-busy', 'true');
      el.claim.textContent = ui.mode === 'edit' ? 'Saving…' : 'Adding…';
    } else {
      el.claim.removeAttribute('aria-busy');
      el.claim.textContent = ui.mode === 'edit' ? saveLabel : claimLabel;
    }
  }

  function friendlyCartError(error) {
    const text = String((error && error.message) || '');
    if (/sold out|not enough|inventory|available|can only add|can.t add more|cannot add/i.test(text)) {
      return 'That tag has just sold out in this size. Please choose another.';
    }
    return 'We couldn’t update your bag just now. Please try again.';
  }

  /* ── Quiet notice ──────────────────────────────────────────────────── */

  // Anything pinned to the bottom of the viewport (the PDP sticky bar, the
  // /cart checkout bar, the size guide and fitting room bars) lifts the
  // notice so the two never overlap.
  const NOTICE_OBSTACLES = ['.pdp-sticky-atc-mobile', '[data-42-sticky-mobile]', '.lb-cu-sticky', '.lb-sg-sticky-bar', '.lb-fr__mbar', '.lb-stickybag', SELECTORS.productProgress];

  // The box that is actually pinned: the element itself or the wrapper that
  // holds it (the phone PDP bar is static inside a fixed wrapper).
  function pinnedBox(node) {
    for (let box = node; box && box !== document.body; box = box.parentElement) {
      const position = window.getComputedStyle(box).position;
      if (position === 'fixed' || position === 'sticky') return box;
    }
    return null;
  }

  function updateNoticeOffset() {
    if (!el.notice) return;
    let offset = 0;
    NOTICE_OBSTACLES.forEach((selector) => {
      document.querySelectorAll(selector).forEach((node) => {
        const box = pinnedBox(node);
        if (!box) return;
        const rect = box.getBoundingClientRect();
        const style = window.getComputedStyle(box);
        // Floating bars count too (the PDP progress bar sits 16px above the edge);
        // the notice keeps its own 12px / 24px margin above whichever is highest.
        const nearBottom = rect.bottom >= window.innerHeight - 48 && rect.top < window.innerHeight;
        const bar = rect.height > 0 && rect.height < window.innerHeight * 0.4;
        if (nearBottom && bar && style.display !== 'none' && style.visibility !== 'hidden') {
          offset = Math.max(offset, Math.ceil(window.innerHeight - rect.top));
        }
      });
    });
    el.notice.style.setProperty('--free-gift-notice-offset', offset + 'px');
  }

  // The cart drawer carries the checkout buttons; the notice never sits
  // over it.
  function isCartDrawerOpen() {
    const drawer = document.querySelector(SELECTORS.shtCartDrawer);
    return !!(drawer && (drawer.classList.contains('active') || drawer.hasAttribute('open')));
  }

  function showNotice() {
    if (!el.notice) return;
    window.clearTimeout(noticeTimer);
    updateNoticeOffset();
    el.notice.hidden = false;
    nextPaint(() => el.notice.classList.add('is-in'));
  }

  function hideNotice() {
    if (!el.notice || el.notice.hidden) return;
    el.notice.classList.remove('is-in');
    window.clearTimeout(noticeTimer);
    noticeTimer = window.setTimeout(() => {
      if (!el.notice.classList.contains('is-in')) el.notice.hidden = true;
    }, reducedMotion() ? 0 : 600);
  }

  // One gift prompt per screen. A product page carries its own progress bar
  // with Claim (pinned at the bottom on desktop, inside the sticky Add to
  // cart bar on phones), and /cart carries the claim row: there the notice
  // would only repeat it.
  function pageHasOwnGiftPrompt() {
    if (document.body && document.body.classList.contains('template-cart')) return true;
    return Array.from(document.querySelectorAll(SELECTORS.productProgress)).some((node) => !node.hidden);
  }

  function maybeShowNotice(cart) {
    const current = cart || lastKnownCart;
    if (!el.notice || !current) return;

    const eligible = eligibleSubtotal(current) >= getActiveThreshold();
    const show = eligible &&
      anyInStock &&
      !hasGift(current) &&
      (isDismissed() || isQuietRequalification(current)) &&
      !isNoticeHidden() &&
      !pageHasOwnGiftPrompt() &&
      modal.hidden &&
      !isCartDrawerOpen() &&
      !isConfiguratorActive();

    if (show) showNotice();
    else hideNotice();
  }

  /* ── Wiring ────────────────────────────────────────────────────────── */

  function initUi() {
    el.designs.forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        ui.design = input.value;
        setError('');
        syncAll();
      });
    });

    el.sizes.forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        ui.size = input.value;
        syncAll();
      });
    });

    el.faces.forEach((button) => {
      button.addEventListener('click', () => setFace(button.dataset.freeGiftFace, true));
    });

    [['name', el.name, sanitizeName], ['phone', el.phone, sanitizePhone]].forEach(([key, input, clean]) => {
      if (!input) return;

      input.addEventListener('input', () => {
        const cleaned = clean(input.value);
        const rejected = cleaned.length < input.value.slice(0, key === 'name' ? NAME_MAX : PHONE_MAX).length;
        if (cleaned !== input.value) {
          const caret = Math.max(0, (input.selectionStart || cleaned.length) - (input.value.length - cleaned.length));
          input.value = cleaned;
          try { input.setSelectionRange(caret, caret); } catch (error) { /* type=tel may refuse */ }
        }
        ui[key] = cleaned;
        setError(rejected
          ? (key === 'name' ? 'Letters, numbers, spaces and . \' - & only.' : 'Digits, spaces, ( ) - and a leading + only.')
          : '');
        setFace(key === 'name' ? 'front' : 'back');
        syncFields();
      });

      input.addEventListener('focus', () => {
        setFace(key === 'name' ? 'front' : 'back', true);
        if (isPhone()) modal.classList.add('is-typing');
        queueFit();
      });

      input.addEventListener('blur', () => {
        window.setTimeout(() => {
          const active = document.activeElement;
          if (active !== el.name && active !== el.phone) modal.classList.remove('is-typing');
          queueFit();
        }, 120);
      });

      input.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        if (input === el.name && el.phone && !el.phone.disabled) el.phone.focus();
        else input.blur();
      });
    });

    if (el.blank) {
      el.blank.addEventListener('change', () => {
        ui.blank = el.blank.checked;
        setError('');
        setFace('front');
        syncAll();
      });
    }

    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') trapFocus(event);
    });

    if (el.notice) {
      el.notice.addEventListener('click', (event) => {
        if (event.target.closest(SELECTORS.noticeOpen)) {
          openModal({ userInitiated: true });
          return;
        }
        if (event.target.closest(SELECTORS.noticeHide)) {
          sessionFlag(SESSION_NOTICE_HIDDEN, true);
          hideNotice();
        }
      });
    }

    // Anything that can change the height available or needed re-fits.
    window.addEventListener('resize', queueFit);
    window.addEventListener('orientationchange', queueFit);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', queueFit);
    if (window.ResizeObserver && el.body) {
      // Watch the content blocks, not just the box: overflow grows inside.
      const watch = new ResizeObserver(queueFit);
      [el.body, ...el.body.children, modal.querySelector('.free-gift-modal__plinth'), modal.querySelector('.free-gift-modal__footer')]
        .filter(Boolean)
        .forEach((node) => watch.observe(node));
    }
    if (el.error && window.MutationObserver) {
      new MutationObserver(queueFit).observe(el.error, { childList: true, characterData: true, subtree: true });
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueFit);

    const drawer = document.querySelector(SELECTORS.shtCartDrawer);
    if (drawer && window.MutationObserver) {
      new MutationObserver(() => maybeShowNotice()).observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
    }

    let raf = 0;
    const reflow = () => {
      if (raf || !el.notice || el.notice.hidden) return;
      raf = window.requestAnimationFrame(() => {
        raf = 0;
        updateNoticeOffset();
      });
    };
    window.addEventListener('scroll', reflow, { passive: true });
    window.addEventListener('resize', reflow);

    syncAll();
  }


  async function changeLine(key, quantity, includeSections) {
    const body = {
      id: key,
      quantity
    };
    const sections = includeSections ? getThemeSectionsToRender() : [];

    if (sections.length) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }

    return fetchJson(buildCartUrl('cart/change.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body),
      [OWN_REQUEST]: true
    });
  }

  function carriedProperties(item) {
    const source = (item && item.properties) || {};
    const carried = {};
    Object.keys(source).forEach((key) => {
      if ([PROPERTY_NAME, SOURCE_PROPERTY, UPGRADE_PROPERTY, CONVERSION_PROPERTY, CONVERTED_PROPERTY].includes(key)) return;
      carried[key] = source[key];
    });
    return carried;
  }

  function findPaidTwin(cart, variantId, conversionId) {
    if (!conversionId) return null;
    return cart.items.find((item) => {
      return Number(item.variant_id) === Number(variantId) &&
        !isGiftLine(item) &&
        String(lineProperty(item, CONVERTED_PROPERTY)) === String(conversionId);
    }) || null;
  }

  function hasPendingGiftConversion(cart) {
    return giftLines(cart).some((item) => {
      return !!findPaidTwin(cart, paidVariantForGift(item), lineProperty(item, CONVERSION_PROPERTY));
    });
  }

  // The paid copy gets a durable link to this particular gift. It both
  // protects an add-success/remove-failure retry from charging twice and
  // keeps renewed eligibility quiet across reloads, only for this cart.
  async function upgradeGifts(cart, options) {
    const onlyPending = !!(options && options.onlyPending);
    const candidates = giftLines(cart).filter((item) => {
      if (!isModalManagedGift(item) && !Number(lineProperty(item, UPGRADE_PROPERTY))) return false;
      return !onlyPending || !!findPaidTwin(cart, paidVariantForGift(item), lineProperty(item, CONVERSION_PROPERTY));
    });
    let updatedCart = cart;
    let upgraded = 0;
    let added = 0;
    const previousPaidIds = new Set(cart.items.filter(isConvertedGiftLine).map((item) => String(lineProperty(item, CONVERTED_PROPERTY))));
    if (!candidates.length) return { cart: updatedCart, upgraded, added };

    isMutatingGift = true;
    try {
      for (const original of candidates) {
        const paidVariantId = paidVariantForGift(original);
        if (!paidVariantId) continue;
        let conversionId = String(lineProperty(original, CONVERSION_PROPERTY) || '');
        let item = updatedCart.items.find((line) => isGiftLine(line) &&
          (conversionId ? String(lineProperty(line, CONVERSION_PROPERTY)) === conversionId : line.key === original.key));
        if (!item) continue;

        if (!conversionId) {
          conversionId = newConversionId();
          updatedCart = await postJson('cart/change.js', withSections({
            id: item.key,
            quantity: Number(item.quantity) || 1,
            properties: { ...item.properties, [CONVERSION_PROPERTY]: conversionId, [UPGRADE_PROPERTY]: String(paidVariantId) }
          }));
          item = updatedCart.items.find((line) => isGiftLine(line) && String(lineProperty(line, CONVERSION_PROPERTY)) === conversionId);
          if (!item) continue;
        }

        const quantity = Math.max(Number(item.quantity) || 1, 1);
        const paid = findPaidTwin(updatedCart, paidVariantId, conversionId);
        const missingQuantity = Math.max(quantity - (Number(paid && paid.quantity) || 0), 0);
        if (missingQuantity > 0) {
          await postJson('cart/add.js', {
            items: [{
              id: paidVariantId,
              quantity: missingQuantity,
              properties: { ...carriedProperties(item), [CONVERTED_PROPERTY]: conversionId }
            }]
          });
          added += 1;
          updatedCart = await getCart();
        }

        const confirmedPaid = findPaidTwin(updatedCart, paidVariantId, conversionId);
        if (!confirmedPaid || Number(confirmedPaid.quantity) < quantity) continue;
        // Adding a paid item can change discount allocations and line keys.
        const currentGift = updatedCart.items.find((line) => isGiftLine(line) && String(lineProperty(line, CONVERSION_PROPERTY)) === conversionId);
        if (!currentGift) continue;
        updatedCart = await changeLine(currentGift.key, 0, true);
        upgraded += 1;
      }
    } catch (error) {
      // A stock or network failure never removes the customer's free line.
      // Own requests do not schedule retries; the next genuine cart change
      // can complete a partial swap using its persisted conversion id.
      console.error('[free-gift] Could not re-price a complimentary line.', error);
      try {
        updatedCart = await getCart();
        if (!added) {
          added = updatedCart.items.filter(isConvertedGiftLine)
            .filter((item) => !previousPaidIds.has(String(lineProperty(item, CONVERTED_PROPERTY)))).length;
        }
      } catch (readError) { /* Keep the last confirmed cart. */ }
    } finally {
      isMutatingGift = false;
    }
    return { cart: updatedCart, upgraded, added };
  }

  function hasEngravingChoice(item) {
    const p = (item && item.properties) || {};
    return ['Front Side Text', 'Back Side Text', 'Engraving', '_engraving_name', '_engraving_phone', '_engraving_blank', 'Engraving name', 'Engraving phone']
      .some((key) => p[key] !== undefined && p[key] !== null && p[key] !== '');
  }

  async function enforceSingleGift(cart) {
    // Keep-first order: engraved lines before plain ones, oldest first
    // (/cart.js lists the newest line first).
    const gifts = modalGiftLines(cart).reverse().sort((a, b) => Number(hasEngravingChoice(b)) - Number(hasEngravingChoice(a)));
    if (!gifts.length) return cart;

    let updatedCart = cart;
    // An externally-granted gift already satisfies the offer, so every
    // modal-owned gift alongside it is a duplicate — stand down rather than
    // leaving the shopper with two free items for one threshold.
    let keptGift = externalGiftLines(cart).length > 0;

    for (const item of gifts) {
      if (!keptGift) {
        keptGift = true;

        if (item.quantity > 1) {
          updatedCart = await changeLine(item.key, 1, true);
        }
      } else {
        updatedCart = await changeLine(item.key, 0, true);
      }
    }

    return updatedCart;
  }

  function getThemeSectionsToRender() {
    const cartDrawer = document.querySelector(SELECTORS.shtCartDrawer);
    const cartNotification = document.querySelector(SELECTORS.shtCartNotification);
    const sections = [];

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sections.push(...cartDrawer.getSectionsToRender());
    }

    if (cartNotification && typeof cartNotification.getSectionsToRender === 'function') {
      sections.push(...cartNotification.getSectionsToRender());
    }

    const sectionIds = sections
      .map((section) => section && section.section)
      .filter(Boolean);

    return Array.from(new Set(sectionIds));
  }

  function openThemeCartDrawer() {
    const cartDrawer = document.querySelector(SELECTORS.shtCartDrawer);
    if (!cartDrawer) return;

    ['open', 'show', 'showDrawer', 'openDrawer'].some((methodName) => {
      if (typeof cartDrawer[methodName] === 'function') {
        cartDrawer[methodName]();
        return true;
      }

      return false;
    });
  }

  function renderThemeCart(sectionResponse, cart, options) {
    if (!sectionResponse || !sectionResponse.sections) return;

    const renderOptions = {
      openDrawer: true,
      ...(options || {})
    };
    const cartDrawerForm = document.querySelector(SELECTORS.shtCartDrawerForm);
    const cartDrawer = document.querySelector(SELECTORS.shtCartDrawer);
    const cartNotification = document.querySelector(SELECTORS.shtCartNotification);
    const renderedState = {
      ...cart,
      sections: sectionResponse.sections
    };

    if (cartDrawerForm && typeof cartDrawerForm.renderContents === 'function') {
      cartDrawerForm.renderContents(renderedState);
    } else if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(renderedState);
    }

    if (cartNotification && typeof cartNotification.getSectionsToRender === 'function') {
      cartNotification.getSectionsToRender().forEach((section) => {
        const target = section.space_selector && document.querySelector(section.space_selector);

        if (
          section.id === 'header-cart-status' &&
          target &&
          typeof cartNotification.getSectionInnerHTML === 'function' &&
          sectionResponse.sections[section.id]
        ) {
          target.innerHTML = cartNotification.getSectionInnerHTML(
            sectionResponse.sections[section.id],
            section.selector
          );
        }
      });
    }

    renderRepricedNotes(cart);

    if (renderOptions.openDrawer) {
      openThemeCartDrawer();
    }
  }

  function postJson(path, body) {
    return fetchJson(buildCartUrl(path), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body),
      // Our own requests already carry the full property bag; the
      // preservation guard in patchFetch() must leave them alone.
      [OWN_REQUEST]: true
    });
  }

  function withSections(body) {
    const sections = getThemeSectionsToRender();
    if (sections.length) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }
    return body;
  }

  // Cart-driven price changes are also announced to screen readers.
  let liveNode = null;
  function speak(text) {
    if (!document.body) return;
    if (!liveNode) {
      liveNode = document.createElement('p');
      liveNode.className = 'visually-hidden';
      liveNode.setAttribute('aria-live', 'polite');
      document.body.appendChild(liveNode);
    }
    liveNode.textContent = '';
    window.setTimeout(() => { liveNode.textContent = text; }, 60);
  }

  function announce(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
  }

  async function addGift(variantId) {
    if (!variantId || isMutatingGift) return;

    isMutatingGift = true;
    setBusy(true);

    try {
      let cart = await getCart();
      cart = await enforceSingleGift(cart);

      if (eligibleSubtotal(cart) < getActiveThreshold() || hasGift(cart)) {
        closeModal();
        return;
      }

      const addResponse = await postJson('cart/add.js', withSections({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: {
              ...engravingProperties(),
              [PROPERTY_NAME]: PROPERTY_VALUE,
              // Claim ownership explicitly so isModalManagedGift() can tell
              // our lines from another surface's.
              [SOURCE_PROPERTY]: SOURCE_SELF,
              [CONVERSION_PROPERTY]: newConversionId(),
              ...(paidVariantForGift({ variant_id: Number(variantId) }) ? { [UPGRADE_PROPERTY]: String(paidVariantForGift({ variant_id: Number(variantId) })) } : {})
            }
          }
        ]
      }));

      const updatedCart = await getCart();

      closeModal('done');
      hideNotice();
      if (reloadIfCartPage()) return;
      renderThemeCart(addResponse, updatedCart);
      updateProgressBars(updatedCart);
      scheduleCartCheck();
      announce('free-gift:added', {
        cart: updatedCart,
        sections: addResponse.sections || {}
      });
      announce('cart:updated', updatedCart);
    } catch (error) {
      console.error('[free-gift] Could not add gift.', error);
      markSoldOutIfSo(error, variantId);
      setError(friendlyCartError(error));
    } finally {
      setBusy(false);
      isMutatingGift = false;
    }
  }

  /* Rewrites the engraving on a gift line that is already in the bag.
   *
   * Same variant: one /cart/change.js with the merged property bag.
   * Different design or size: add the new variant first, then retire the
   * old line, so a failure leaves the shopper holding a tag rather than
   * nothing (the same order upgradeGifts() uses).
   */
  async function saveEngraving() {
    if (isMutatingGift || !ui.editLine) return;

    isMutatingGift = true;
    setBusy(true);

    try {
      const cart = await getCart();
      const line = cart.items.find((item) => item.key === ui.editLine.key) ||
        cart.items.find((item) => isGiftLine(item) && Number(item.variant_id) === Number(ui.editLine.variant_id));

      if (!line) {
        setError('This tag is no longer in your bag.');
        return;
      }

      const target = variantFor(ui.design, ui.size);
      const properties = withEngraving(line.properties, engravingProperties());
      // A line the old popup already stripped gets its markers back. Only
      // our own gift variants are re-stamped as ours.
      if (!properties[PROPERTY_NAME]) properties[PROPERTY_NAME] = PROPERTY_VALUE;
      if (!properties[SOURCE_PROPERTY] && giftVariantIds.includes(Number(line.variant_id))) {
        properties[SOURCE_PROPERTY] = SOURCE_SELF;
      }
      let response;

      // A Fitting Room gift carries the paid twin it turns into if the bag
      // later drops below the threshold. Changing design or size must move
      // that pointer too, or the shopper is later charged for the old tag.
      if (target && isModalManagedGift(line)) {
        const paidId = paidVariantForGift({ variant_id: Number(target.id) });
        if (paidId) properties[UPGRADE_PROPERTY] = String(paidId);
        else delete properties[UPGRADE_PROPERTY];
      } else if (target && Number(target.id) !== Number(line.variant_id) && properties[UPGRADE_PROPERTY]) {
        if (Number(target.paid) > 0) properties[UPGRADE_PROPERTY] = String(target.paid);
      }
      if (!properties[CONVERSION_PROPERTY]) properties[CONVERSION_PROPERTY] = newConversionId();

      if (target && Number(target.id) !== Number(line.variant_id)) {
        await postJson('cart/add.js', {
          items: [{ id: Number(target.id), quantity: Number(line.quantity) || 1, properties }]
        });
        response = await changeLine(line.key, 0, true);
      } else {
        response = await postJson('cart/change.js', withSections({
          id: line.key,
          quantity: Number(line.quantity) || 1,
          properties
        }));
      }

      const updatedCart = await getCart();

      closeModal('done');
      if (reloadIfCartPage()) return;
      renderThemeCart(response, updatedCart);
      updateProgressBars(updatedCart);
      scheduleCartCheck();
      announce('free-gift:engraving-saved', { cart: updatedCart });
      announce('cart:updated', updatedCart);
    } catch (error) {
      console.error('[free-gift] Could not save engraving.', error);
      const target = variantFor(ui.design, ui.size);
      markSoldOutIfSo(error, target && target.id);
      setError(friendlyCartError(error));
    } finally {
      setBusy(false);
      isMutatingGift = false;
    }
  }

  // The page can be older than the stock: if Shopify refuses a variant as
  // sold out, mark it so here and let the selection move to what is left.
  function markSoldOutIfSo(error, variantId) {
    if (!/sold out|not enough|inventory|available|can only add|can.t add more|cannot add/i.test(String((error && error.message) || ''))) return;
    giftProducts.forEach((product) => (product.variants || []).forEach((variant) => {
      if (Number(variant.id) === Number(variantId)) variant.available = false;
    }));
    syncAll();
  }

  // /cart is server-rendered and has no section endpoint wired to this
  // script, so after a change there the page reloads rather than showing
  // the old line (and an edit button pointing at a dead key).
  function reloadIfCartPage() {
    const onCart = !!document.body && document.body.classList.contains('template-cart');
    if (onCart) window.location.reload();
    return onCart;
  }

  function submitSelection() {
    if (!validate()) return;
    if (ui.mode === 'edit') {
      saveEngraving();
      return;
    }
    const variant = variantFor(ui.design, ui.size);
    addGift(variant && variant.id);
  }

  async function openEditor(lineKey) {
    try {
      const cart = await getCart();
      lastKnownCart = cart;
      // A drawer that was not re-rendered can hold a stale key; there is only
      // ever one gift line, so fall back to it.
      const line = cart.items.find((item) => item.key === lineKey && isGiftLine(item)) ||
        cart.items.find(isGiftLine);
      if (line) {
        openModal({ userInitiated: true, editLine: line });
      }
    } catch (error) {
      console.error('[free-gift] Could not open the engraving editor.', error);
    }
  }

  /* Safety net for OTHER code that edits a gift line.
   *
   * The theme's generic "Personalise" popup (bundle.js) saves by posting
   * { id, properties: { "Front Side Text", "Back Side Text" } } to
   * /cart/change.js. Shopify replaces the whole property bag on that call,
   * which silently deleted _free_gift, _free_gift_source and the Fitting
   * Room's _free_gift_upgrade_variant — the markers every cleanup path in
   * this file depends on. The cart templates now route gift lines to this
   * modal instead, but any caller that still posts a bare property bag for
   * a gift line has it merged here, synchronously, before it leaves.
   */
  function findChangedLine(cart, data) {
    if (!cart || !Array.isArray(cart.items)) return null;
    if (typeof data.id === 'string' && data.id.indexOf(':') > -1) {
      return cart.items.find((item) => item.key === data.id) || null;
    }
    if (Number(data.line) > 0) {
      return cart.items[Number(data.line) - 1] || null;
    }
    if (data.id !== undefined) {
      return cart.items.find((item) => Number(item.variant_id) === Number(data.id)) || null;
    }
    return null;
  }

  function preserveGiftProperties(rawBody) {
    if (typeof rawBody !== 'string' || rawBody.indexOf('properties') === -1) return rawBody;

    let data;
    try {
      data = JSON.parse(rawBody);
    } catch (error) {
      return rawBody;
    }

    if (!data || typeof data !== 'object' || !data.properties || typeof data.properties !== 'object') {
      return rawBody;
    }

    const line = findChangedLine(lastKnownCart, data);
    if (!line || (!isGiftLine(line) && !isConvertedGiftLine(line))) return rawBody;

    const incoming = data.properties;
    const engraving = {};
    Object.keys(incoming).forEach((key) => {
      const value = incoming[key];
      if (value === null || value === undefined || value === '') return;
      engraving[key] = value;
      if (key === ENGRAVING.front) engraving[ENGRAVING.privateName] = value;
      if (key === ENGRAVING.back) engraving[ENGRAVING.privatePhone] = value;
    });

    data.properties = withEngraving(line.properties, engraving);
    if (isGiftLine(line) && !data.properties[PROPERTY_NAME]) data.properties[PROPERTY_NAME] = PROPERTY_VALUE;
    if (isGiftLine(line) && !data.properties[SOURCE_PROPERTY] && giftVariantIds.includes(Number(line.variant_id))) {
      data.properties[SOURCE_PROPERTY] = SOURCE_SELF;
    }
    return JSON.stringify(data);
  }

  function isCartChangeUrl(url) {
    const stringUrl = typeof url === 'string' ? url : url && url.url;
    return !!stringUrl && stringUrl.indexOf('/cart/change') > -1;
  }

  async function checkCartState() {
    if (isChecking || isMutatingGift) {
      // A cart event arrived mid-check: run once more when this one ends,
      // or a cart that just fell below the threshold could keep its gift.
      recheckQueued = true;
      return;
    }

    isChecking = true;

    try {
      let cart = await getCart();
      const subtotal = eligibleSubtotal(cart);

      if (subtotal < getActiveThreshold() || hasPendingGiftConversion(cart)) {
        closeModal();
        hideNotice();
        // Our own withdrawal below — not the shopper's choice.
        lastHadGift = false;

        // While a gift line is being withdrawn, the drawer's +/−/remove
        // buttons address lines by index; a click landing in between would
        // change the wrong line. Hold them until the cart has settled.
        const drawerForm = document.querySelector(SELECTORS.shtCartDrawerForm);
        const holdDrawer = !!drawerForm && typeof drawerForm.updateButtonState === 'function' &&
          (modalGiftLines(cart).length > 0 || externalGiftLines(cart).length > 0);
        if (holdDrawer) drawerForm.updateButtonState(true);

        let upgrade;
        try {
          upgrade = await upgradeGifts(cart, { onlyPending: subtotal >= getActiveThreshold() });
          cart = upgrade.cart;
        } finally {
          if (holdDrawer) drawerForm.updateButtonState(false);
        }

        const changed = upgrade.upgraded > 0 || upgrade.added > 0;

        // Unconditional: pure local bookkeeping, dispatches nothing, and
        // gating it would desync the progress bar from the cart.
        updateProgressBars(cart);

        // THE LOOP GUARD. Everything below announces a cart mutation, and
        // "cart:updated" is one of this function's own triggers — so
        // announcing when nothing changed re-entered here every 350ms
        // forever on any sub-threshold cart, an empty one included. Now the
        // chain is only extended when the cart genuinely moved, which is
        // self-limiting: the follow-up pass finds nothing left to do and
        // stops.
        if (!changed) return;

        // /cart lists lines by index: a page that still shows the removed
        // gift would send the next quantity change to the wrong line.
        if (reloadIfCartPage()) return;

        renderThemeCart(cart, cart, { openDrawer: false });
        if (upgrade.upgraded > 0) {
          speak('Your personalised name tag is now a paid item. Your engraving has been kept.');
        }
        document.dispatchEvent(new CustomEvent('free-gift:repriced', {
          bubbles: true,
          detail: {
            cart,
            sections: cart.sections || {},
            upgraded: upgrade.upgraded,
            removed: 0
          }
        }));
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: cart
        }));
        return;
      }

      const beforeEnforce = cart;
      cart = await enforceSingleGift(cart);
      updateProgressBars(cart);

      if (cart !== beforeEnforce) {
        if (reloadIfCartPage()) return;
        renderThemeCart(cart, cart, { openDrawer: false });
      }

      const editing = ui.mode === 'edit' && !modal.hidden;
      const giftNow = hasGift(cart);

      // The gift was in the bag a moment ago and the bag still qualifies:
      // the shopper took it out. Re-offering it on the spot reads as the
      // store arguing; treat it as "Not now" — the quiet notice stays.
      if (!giftNow && lastHadGift === true && !editing && !isMutatingGift && !isConfiguratorActive()) {
        sessionFlag(SESSION_DISMISSED, true);
      }
      lastHadGift = giftNow;

      if (!giftNow) {
        if (editing) {
          // The line being edited left the bag (another tab, a removal).
          closeModal();
        } else if (isDismissed() || isQuietRequalification(cart)) {
          maybeShowNotice(cart);
        } else {
          openModal();
        }
      } else {
        // Never yank the editor away mid-edit because the cart changed.
        if (!editing) closeModal();
        hideNotice();
      }
    } catch (error) {
      console.error('[free-gift] Could not check cart.', error);
    } finally {
      isChecking = false;
      if (recheckQueued) {
        recheckQueued = false;
        scheduleCartCheck();
      }
    }
  }

  function scheduleCartCheck(delay) {
    window.clearTimeout(checkTimer);
    checkTimer = window.setTimeout(checkCartState, typeof delay === 'number' ? delay : CHECK_DELAY);
  }

  function isCartObject(value) {
    // /cart/add.js answers { items: [the added lines] }, which is NOT the
    // cart. Treating it as one set the progress bar (and lastKnownCart)
    // from the added line alone. Full cart payloads carry item_count.
    return !!value && Array.isArray(value.items) && typeof value.item_count === 'number';
  }

  function normalizeProgressFromCart(cart) {
    if (!isCartObject(cart)) return;

    lastKnownCart = cart;
    window.requestAnimationFrame(() => {
      updateProgressBars(cart);
    });
  }

  function isCartMutationUrl(url) {
    if (!url) return false;

    const stringUrl = typeof url === 'string' ? url : url.url;
    if (!stringUrl) return false;

    return CART_ENDPOINTS.some((endpoint) => stringUrl.includes(endpoint));
  }

  function patchFetch() {
    if (!window.fetch || window.fetch.__freeGiftPatched) return;

    const originalFetch = window.fetch;

    window.fetch = function patchedFetch(input, init) {
      const trackMutation = isCartMutationUrl(input) && !(init && init[OWN_REQUEST]);
      if (trackMutation) {
        captureCurrentProgressPercent();
      }

      let args = arguments;
      if (init && !init[OWN_REQUEST] && isCartChangeUrl(input) && typeof init.body === 'string') {
        const body = preserveGiftProperties(init.body);
        if (body !== init.body) args = [input, { ...init, body }];
      }

      const promise = originalFetch.apply(this, args);

      if (trackMutation) {
        promise
          .then((response) => {
            if (!response || typeof response.clone !== 'function') return;

            response.clone().json()
              .then(normalizeProgressFromCart)
              .catch(() => {});
          })
          .catch(() => {});

        promise.then(() => scheduleCartCheck(), () => scheduleCartCheck());
      }

      return promise;
    };

    window.fetch.__freeGiftPatched = true;
  }

  function patchXhr() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.__freeGiftPatched) return;

    const originalOpen = window.XMLHttpRequest.prototype.open;
    const originalSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function patchedOpen(method, url) {
      this.__freeGiftUrl = url;
      return originalOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function patchedSend(body) {
      let args = arguments;
      if (isCartChangeUrl(this.__freeGiftUrl) && typeof body === 'string') {
        const preserved = preserveGiftProperties(body);
        if (preserved !== body) args = [preserved];
      }

      if (isCartMutationUrl(this.__freeGiftUrl)) {
        captureCurrentProgressPercent();
        this.addEventListener('loadend', () => {
          try {
            normalizeProgressFromCart(JSON.parse(this.responseText));
          } catch (error) {
            // The cart endpoint can return non-cart payloads, for example cart/add.
          }

          scheduleCartCheck();
        });
      }

      return originalSend.apply(this, args);
    };

    window.XMLHttpRequest.__freeGiftPatched = true;
  }

  function observeProgressRenders() {
    if (!window.MutationObserver || !document.body) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const hasProgress = (node.matches && node.matches(SELECTORS.progress)) ||
              (node.querySelector && node.querySelector(SELECTORS.progress));

            if (hasProgress) {
              if (lastKnownCart) {
                updateProgressBars(lastKnownCart);
              }
              scheduleCartCheck(0);
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function bindEvents() {
    modal.addEventListener('click', (event) => {
      if (event.target.closest(SELECTORS.close)) {
        closeModal(event.target.closest(SELECTORS.dismiss) ? 'dismiss' : undefined);
        return;
      }

      if (event.target.closest(SELECTORS.claim)) {
        if (!modal.classList.contains('is-loading')) submitSelection();
      }
    });

    // "Change engraving" on a gift line in the drawer or on /cart.
    document.addEventListener('click', (event) => {
      const edit = event.target.closest(SELECTORS.edit);
      if (!edit) return;
      event.preventDefault();
      openEditor(edit.getAttribute('data-free-gift-edit'));
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;

      if (form && form.matches && form.matches(SELECTORS.cartForm)) {
        scheduleCartCheck();
      }
    }, true);

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest(SELECTORS.progressToggle);
      if (toggle) {
        toggleProductProgress(toggle.closest(SELECTORS.productProgress));
        return;
      }

      if (event.target.closest(SELECTORS.progressClaim) || event.target.closest(SELECTORS.progressClaimMobile)) {
        // Explicit request — never suppressed.
        openModal({ userInitiated: true });
      }
    });

    // Normal behaviour resumes when the configurator leaves the page. On the
    // usual path this never fires — the Fitting Room navigates to /cart, and
    // the fresh page evaluates from scratch. It matters for the teardown
    // cases that do NOT reload: a theme-editor section swap, or any future
    // drawer-mounted configurator.
    //
    // Routed through the same scheduleCartCheck debounce as every other
    // trigger, so an exit that coincides with a cart event collapses into
    // ONE evaluation rather than two — no double-trigger, no flash.
    document.addEventListener('lillebjorn:fitting-room-closed', scheduleCartCheck);
    // Find My Dog's Size closed: an offer held back while it was open can show now.
    document.querySelectorAll('lillebjorn-fit-finder').forEach((finder) => {
      new MutationObserver(() => {
        if (finder.getAttribute('data-open') !== 'true') scheduleCartCheck(0);
      }).observe(finder, { attributes: true, attributeFilter: ['data-open'] });
    });

    document.addEventListener('cart:updated', scheduleCartCheck);
    document.addEventListener('cart:change', scheduleCartCheck);
    document.addEventListener('cart:refresh', scheduleCartCheck);
    document.addEventListener('ajaxProduct:added', scheduleCartCheck);
    document.addEventListener('product:added', scheduleCartCheck);

    document.addEventListener('keydown', (event) => {
      // Escape belongs to a native modal dialog when one is on top of us.
      if (event.key === 'Escape' && !modal.hidden && !openNativeModal()) {
        closeModal('dismiss');
      }
    });

    window.addEventListener('resize', updateProductProgressOffset);
  }

  initUi();
  patchFetch();
  patchXhr();
  observeProgressRenders();
  bindEvents();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      updateProductProgressOffset();
      checkCartState();
    }, { once: true });
  } else {
    updateProductProgressOffset();
    checkCartState();
  }
})();
